import React from 'react';
import { Feather, Sneaker } from '@phosphor-icons/react';
import { Section, ListGroup } from '../ui';

// Week-level tips + gear notes (handoff_app_design/README.md §5.2). One List group for tips, one
// plain surface-2 row for gear — never framed as a card.
//
// Data note: plan.tips_summary is an array of plain Hebrew sentences (no separate title or a
// "race-related" flag), while the reference mockup shows each tip as an icon + a short bold title
// + one sentence, with the icon tinted quality for race-related tips. Without that structure in
// the data, every tip renders with one icon (Feather, accent-soft) and the sentence as the row's
// only text — no title is invented, and no tip is guessed to be "race-related".
//
// Props:
//   tips      — array of Hebrew strings (plan.tips_summary)
//   gearNotes — single Hebrew string (plan.gear_notes)
export default function TipsList({ tips = [], gearNotes }) {
  const hasTips = Array.isArray(tips) && tips.length > 0;
  const hasGear = gearNotes && gearNotes.trim().length > 0;
  if (!hasTips && !hasGear) return null;

  return (
    <div className="flex flex-col gap-4">
      {hasTips && (
        <Section title="טיפים לשבוע">
          <ListGroup>
            {tips.map((tip, i) => (
              <div key={i} className="flex gap-3 px-4 py-3.5 border-b border-divider last:border-b-0">
                <span className="w-[34px] h-[34px] rounded-control bg-accent-soft text-accent shrink-0 flex items-center justify-center">
                  <Feather size={18} weight="bold" />
                </span>
                <p className="flex-1 min-w-0 m-0 font-medium text-[14px] leading-relaxed text-text-body">{tip}</p>
              </div>
            ))}
          </ListGroup>
        </Section>
      )}

      {hasGear && (
        <Section title="ציוד">
          <div className="flex gap-3 items-start px-4 py-3.5 rounded-card bg-surface-2 border border-border">
            <Sneaker size={21} weight="bold" className="text-text-muted shrink-0 mt-0.5" />
            <p className="flex-1 min-w-0 m-0 font-medium text-[14px] leading-relaxed text-text-body">{gearNotes}</p>
          </div>
        </Section>
      )}
    </div>
  );
}
